import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;
const CACHE_KEY = 'tinypdfs:site-content:v2';
const CACHE_MS = 10 * 60 * 1000;

let memoryCache = null;
let contentRequest = null;

function readCache() {
  if (memoryCache) return memoryCache;
  if (typeof window === 'undefined') return null;
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(CACHE_KEY) || 'null');
    if (stored?.expiresAt > Date.now() && Array.isArray(stored.items)) {
      memoryCache = stored.items;
      return memoryCache;
    }
  } catch {
    // Session storage is an optional optimization.
  }
  return null;
}

function writeCache(items) {
  memoryCache = items;
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({
      expiresAt: Date.now() + CACHE_MS,
      items,
    }));
  } catch {
    // Session storage is an optional optimization.
  }
}

function retryDelay(error) {
  const retryAfter = Number(error?.response?.headers?.['retry-after']);
  if (Number.isFinite(retryAfter) && retryAfter > 0) {
    return Math.min(retryAfter * 1000, 5000);
  }
  return 800;
}

async function fetchAllContent() {
  try {
    return await axios.get(`${API}/content`, { timeout: 10000 });
  } catch (error) {
    if (error?.response?.status !== 429) throw error;
    await new Promise((resolve) => setTimeout(resolve, retryDelay(error)));
    return axios.get(`${API}/content`, { timeout: 10000 });
  }
}

export async function loadAllSiteContent() {
  const cached = readCache();
  if (cached) return cached;
  if (contentRequest) return contentRequest;

  contentRequest = fetchAllContent()
    .then((response) => {
      const items = Array.isArray(response.data) ? response.data : [];
      writeCache(items);
      return items;
    })
    .finally(() => {
      contentRequest = null;
    });
  return contentRequest;
}

export async function loadSiteContentPage(page) {
  const items = await loadAllSiteContent();
  return items.filter((item) => item?.page === page);
}

export function clearSiteContentCache() {
  memoryCache = null;
  contentRequest = null;
  if (typeof window !== 'undefined') {
    try {
      window.sessionStorage.removeItem(CACHE_KEY);
    } catch {
      // ignore
    }
  }
}

